import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://social-auto-r8we.onrender.com/api/campaigns';

export const createCampaign = createAsyncThunk(
    'campaign/create',
    async (campaignData, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(API_URL, campaignData, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const getCampaigns = createAsyncThunk(
    'campaign/getAll',
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.get(API_URL, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

const campaignSlice = createSlice({
    name: 'campaign',
    initialState: {
        campaigns: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createCampaign.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCampaign.fulfilled, (state, action) => {
                state.loading = false;
                state.campaigns.unshift(action.payload);
            })
            .addCase(createCampaign.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getCampaigns.fulfilled, (state, action) => {
                state.campaigns = action.payload;
            });
    },
});

export const { clearError } = campaignSlice.actions;
export default campaignSlice.reducer;
